import { Box, Stack, Stepper, Center } from '@mantine/core';
import { DRAWER_PADDING } from 'utils/general';
import { useTranslation } from 'react-i18next';
import { RuleItem, RuleStatuses } from 'models/rules';
import { useGetRule } from 'hooks/api/rule/useGetRule';
import { CenteredLoading } from 'components/CenteredLoading';
import { useParameters } from 'hooks/useParameters';
import { ReviewRuleForm } from './ReviewRuleForm';
import { DefineRuleForm } from './DefineRule/DefineRuleForm';
import { DraftRuleForm } from './DraftRuleForm';
import { ApprovedRuleForm } from './ApprovedRuleForm';

interface Props {
  createItem?: Pick<RuleItem, 'patientId' | 'groupId'>;
}

export const RuleDrawer = ({ createItem }: Props) => {
  const { t } = useTranslation();
  const { parameters: filters } = useParameters();
  const { data: detailItem } = useGetRule({ id: filters.detailId });

  const pickState = (status?: string) => {
    if (!status) return 0;
    if (status === RuleStatuses.draft) return 1;
    if (status === RuleStatuses.inReview) return 2;
    if (status === RuleStatuses.approved) return 3;
    if (status === RuleStatuses.enabled) return 4;
    return 0;
  };

  const activeState = pickState(detailItem?.status);

  if (!detailItem && !createItem) {
    return (
      <Box px={DRAWER_PADDING}>
        <CenteredLoading />
      </Box>
    );
  }

  return (
    <Box px={DRAWER_PADDING}>
      <Stack>
        <Center>
          <Stepper active={activeState}>
            <Stepper.Step label={t('define_rule_label')} />
            <Stepper.Step label={t('review_confirm_label')} />
            <Stepper.Step label={t('approved_label')} />
          </Stepper>
        </Center>
        {!detailItem && createItem && <DefineRuleForm createItem={createItem} />}
        {detailItem && activeState === 1 && <DraftRuleForm item={detailItem} />}
        {detailItem && activeState === 2 && <ReviewRuleForm item={detailItem} />}
        {detailItem && activeState === 3 && <ApprovedRuleForm item={detailItem} />}
        {detailItem && activeState === 4 && <ApprovedRuleForm item={detailItem} />}
      </Stack>
    </Box>
  );
};
